<template>
  <div>
    <el-dialog
      :title="$t('common.addAdsenseBatch')"
      :visible.sync="visible"
      :width="$i18n.locale == 'zh'? '600px': '700px'"
      :close-on-click-modal="false"
      :before-close="closeDialog">
      <el-form ref="form" :model="form" :rules="formRules" :label-width="$i18n.locale == 'zh'? '110px': '200px'" label-position="left">
        <!-- <el-form-item :label="$t('table.coArea')" prop="area">
          <el-radio-group v-model="form.area" @change="handleAreaChange">
            <el-radio v-for="(item,index) in $com.areaList" :label="item.id">{{$i18n.locale == 'zh'?item.name : item.en_name}}</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="$t('table.accessMode')">
          <el-radio-group v-model="docking_type" @change="dockingChange">
            <el-radio  :label="1">SDK</el-radio>
            <el-radio  :label="2">API</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('table.appName')" prop="application_id">
          <el-select 
            v-model="form.application_id" 
            filterable
            multiple
            collapse-tags
            :placeholder="$t('common.selectApp')"
            style="width: 300px;"
          >
            <el-option
              v-for="(item,index) in applicationList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.coMode')" prop="co_mode">
          <el-select 
            v-model="form.co_mode" 
            filterable 
            :placeholder="$t('common.selectMode')"
            style="width: 300px;"
            @change="comodeChange"
          >
              <el-option
              v-for="(item,index) in $com.modeList"
              :key="item.id"
              :label="$i18n.locale == 'zh'?item.name : item.en_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="form.co_mode == 1">
          <el-form-item :label="$t('table.zhpdPrice')" prop="min_price">
            <div  style="display: flex;">
              <el-input v-model="form.min_price" style="width: 300px;" @blur="priceBlur">
              </el-input> 
              <span> {{form.co_mode == 1 && form.area == 2? $t('common.meiyuan'): $t('common.yuan')}}/cpm</span>
            </div>
          </el-form-item>
        </div>
        <el-form-item :label="$t('sdk.flowType')" prop="flow_types">
          <el-select 
            v-model="form.flow_types" 
            filterable 
            multiple
            collapse-tags
            :placeholder="$t('common.selectFlowType')"
            style="width: 300px;"
            @change="flowTypeChange"
          >
              <el-option
              v-for="(item,index) in flowTypeList"
              :key="item.id"
              :label="$i18n.locale == 'zh'?item.name : item.en_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('sdk.createNum')" prop="batch_num">
          <el-input-number v-model="form.batch_num" :min="1" :max="10"></el-input-number>
        </el-form-item>
        <!-- CSV文件上传 -->
        <el-form-item label="自定义名称" class="upload-form-item">
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :limit="1"
            accept=".csv"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :file-list="fileList"
            action=""
          >
            <el-button size="small" type="primary">选择CSV文件</el-button>
            <div slot="tip" class="el-upload__tip">
              <span>可选：上传CSV文件自定义广告位名称，不校验添加了多少行广告位，如上传的数量小于添加数量，则后续无命名的随机生成</span>
              <el-button type="text" size="small" @click.prevent="downloadTemplate">下载模板</el-button>
            </div>
          </el-upload>
          <!-- 预览解析结果 -->
          <div v-if="previewNames.length > 0" class="preview-box">
            <el-tag type="success" size="small">已解析 {{ previewNames.length }} 个自定义名称</el-tag>
            <el-button type="text" size="small" @click="showPreviewDialog = true">查看详情</el-button>
          </div>
        </el-form-item>
        <!-- 条件展示，当【对接方式】为SDK且【流量类型】有【信息流】时展示；默认平台渲染、可切换自渲染；
            其他非【信息流】的【渲染方式】默认为【平台渲染】 -->
        <!-- 只有国内SDK展示渲染方式，，海外SDk、API均不展示 -->
        <!-- 信息流渲染方式 -->
        <el-form-item :label="$t('common.informationMothod')" v-if="(form.area === 1 && docking_type === 1)" prop="rendering_type">
          <el-radio-group v-model="form.rendering_type">
            <el-radio-button :label="1" v-if="!isOnlyNative">{{$t('sdk.platformRender')}}</el-radio-button>
            <!-- 国内SDK-信息流支持平台渲染和自渲染，国外Native支持自渲染 -->
            <el-radio-button :label="2" v-if="showSelfRender">{{$t('sdk.selfRender')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="Object.keys(typeTemplateMap).length">
          <el-form-item
            v-for="(item, index) in typeTemplateMap"
            :key="index"
            :label="item.name">
            <el-checkbox-group v-model="form.flow_template[item.key]">
              <el-checkbox
                v-for="item in item.templates"
                :label="item.template_id"
                :key="item.template_id">
                {{ $i18n.locale === 'zh' ? item.name : item.en_name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div v-if="form.area == 1">
          <!-- 可投小程序 -->
          <el-form-item :label="$t('common.miniProgram')">
            <el-radio-group v-model="form.is_miniprogram">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 可投快应用 -->
          <el-form-item :label="$t('common.quickApp')">
            <el-radio-group v-model="form.is_fast_app">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 可投应用唤起 -->
          <el-form-item :label="$t('common.appWakeup')">
            <el-radio-group v-model="form.is_deeplink">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 可投下载apk -->
          <el-form-item :label="$t('common.APKDownload')">
            <el-radio-group v-model="form.is_download_apk">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 可投诱导素材 -->
          <el-form-item :label="$t('common.engagementMaterial')">
            <el-radio-group v-model="form.is_induce_material">
              <el-radio-button v-for="item in $com.yesOrNo" :key="item.id" :label="item.id">{{ $i18n.locale == 'zh'?item.name : item.en_name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="onSave" :disabled="isDisabled">{{$t('save')}}</el-button>
      </span>
    </el-dialog>

    <!-- 预览对话框 -->
    <el-dialog
      title="自定义名称预览"
      :visible.sync="showPreviewDialog"
      width="600px"
    >
      <el-table :data="previewTableData" max-height="400">
        <el-table-column prop="index" label="序号" width="80" align="center" />
        <el-table-column prop="name" label="广告位名称" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPreviewDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import util from '@/utils/util'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDisabled: false, // 防止重复点击
      timer: null,
      docking_type: 1,
      // CSV文件上传相关
      fileList: [],
      selectedFile: null,
      previewNames: [],
      showPreviewDialog: false,
      form: {
        application_id: [], //应用id
        co_mode: 2, //合作模式
        min_price: null, //pd价格
        flow_types: [], //流量类型
        rendering_type: 1, //渲染方式
        // area: 1, //合作地区，默认国内
        area: 1, // 合作地区（1国内 2海外）
        batch_num: 1, // 新增参数 添加广告位数量，范围 [1-10]
        template_id: [],//对应流量类型下的模版，默认都选
        flow_template: {}, 
        style: [], //样式选择-平台渲染：默认都选
        elements: [], // 元素配置-自渲染：默认都选
        video_sound: 0, //视频声音 默认静音
        video_auto_play: 0, //视频自动播放 默认不自动播放
        callback_url: "", //回调控制 无需服务器判断
        callback_key: "", //回调控制 无需服务器判断
        is_miniprogram: 1,
        is_fast_app: 1,
        is_deeplink: 1,
        is_download_apk: 1,
        is_induce_material: 1    
      },
      formRules: {
        application_id: [
          { required: true, message: this.$t('common.selectApp'), trigger: 'change' }
        ],
        co_mode: [
          { required: true, message: this.$t('common.selectMode'), trigger: 'change' }
        ],
        min_price: [
          { required: true, message: this.$t('required.pdPrice'), trigger: "blur"},
        ],
        flow_types: [
          { required: true, message: '请选择流量类型', trigger: 'change' }
        ],
        rendering_type: [
          { required: true, message: '请选择渲染方式', trigger: 'change' }
        ],
      },
      appList: [],
      typeTemplateMap: {},
      SHOW_TEMPLATE_TYPES: [2, 7, 10] // 信息流、激励视频、OTT
    }
  },
  computed: {
    applicationList() {
      return this.appList.filter(item => item.docking_type == this.docking_type)
    },
    // 预览表格数据
    previewTableData() {
      return this.previewNames.map((name, index) => ({
        index: index + 1,
        name
      }))
    },
    // 判断是否仅包含Native类型
    isOnlyNative() {
      return this.form.flow_types.length === 1 && 
             this.form.flow_types.includes(11)
    },
    
    // 自渲染显示条件
    showSelfRender() {
      const hasInfoFlow = this.form.flow_types.includes(2) // 信息流
      const hasNative = this.form.flow_types.includes(11) // Native
      
      // 国内：信息流允许自渲染 | 海外：Native强制自渲染
      return (this.form.area === 1 && hasInfoFlow) || 
             (this.form.area === 2 && hasNative)
    },
    flowTypeList() {
      // $com.flowTypeList
      // 返回对应【对接方式】的流量类型
      // SDK(1): [1,2,3,4,7]; API(2):[5,6,8,9,10]
      // this.$com.flowTypeList.forEach(flow => {
      //   flow.show = ((this.docking_type == 1 && [1,2,3,4,7].includes(flow.id)) || (this.docking_type == 2) && flow.id !== 11);
      // });
      // return this.$com.flowTypeList

      // 新的调整-20250409
      // 1. 国内：SDK(1): [2,1,4,3,7]; API(2):[2,1,4,3,7,5,8,9,6,10]
      // 2. 海外：SDK(1): [1,4,7,11]; API(2):[1,4,7,11]
      // 根据地区和接入方式确定流量类型
      let validIds = []
      if (this.form.area === 1) { // 国内
        if (this.docking_type === 1) { // 国内SDK
          validIds = [2,1,4,3,7] // 信息流、开屏、Banner、插屏、激励视频
        } else { // 国内API
          validIds = [2,1,4,3,7,5,8,9,6,10] // 含角标、暂停广告等
        }
      } else { // 海外
        validIds = [1,4,7,11,3] // 开屏、Banner、激励视频、Native、插屏
      }
      return this.$com.flowTypeList.filter(flow => validIds.includes(flow.id))
    },
  },
  watch: {
    'form.flow_types': {
      handler(newVal) {
        const map = {}          
        Object.keys(this.form.flow_template).forEach(k => {
          if (!newVal.includes(Number(k))) this.$delete(this.form.flow_template, k)
        })

        this.$com.flowTypeList.forEach(flow => {
          if (!newVal.includes(flow.id)) return
          const tplIds = (flow.template || []).map(t => t.template_id)
          if (this.SHOW_TEMPLATE_TYPES.includes(flow.id)) {
            map[flow.id] = {
              key: flow.id,
              name: `${this.$i18n.locale === 'zh' ? flow.name : flow.en_name}-模板`,
              templates: flow.template
            }
            if (!Array.isArray(this.form.flow_template[flow.id])) {
              this.$set(this.form.flow_template, flow.id, [])
            }
          } else {

            this.$set(this.form.flow_template, flow.id, tplIds)
          }
        })
        this.typeTemplateMap = map
      },
      immediate: true
    }
  },
  created() {
    this.getAPPList()
  },
  beforeDestroy() {
    if(this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    closeDialog() {
      this.$nextTick(() => {
        this.docking_type = 1
        this.$refs.form.resetFields()
        // 清空文件上传相关数据
        this.fileList = []
        this.selectedFile = null
        this.previewNames = []
        this.showPreviewDialog = false
      })
      this.$emit('updateVisible', false);
    },
    // 下载CSV模板
    async downloadTemplate() {
      try {
        const token = util.getCookie('token')
        const response = await fetch('/developer/api/adZone/downloadTemplate', {
          method: 'GET',
          headers: {
            'Authorization': token
          }
        })

        if (!response.ok) {
          throw new Error('下载失败')
        }

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'adzone_names_template.csv'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)

        this.$message.success('模板下载成功')
      } catch (error) {
        this.$message.error('模板下载失败: ' + error.message)
      }
    },
    // 文件选择后解析预览
    async handleFileChange(file, fileList) {
      // 验证文件
      if (!file.name.endsWith('.csv')) {
        this.$message.error('只支持CSV格式文件')
        this.fileList = []
        return false
      }

      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件大小不能超过10MB')
        this.fileList = []
        return false
      }

      this.selectedFile = file.raw
      this.fileList = [file]

      // 调用解析接口预览
      const formData = new FormData()
      formData.append('names_file', file.raw)

      try {
        const token = util.getCookie('token')
        const response = await fetch('/developer/api/adZone/parseNamesFile', {
          method: 'POST',
          headers: {
            'Authorization': token
          },
          body: formData
        })

        const result = await response.json()

        if (result.code === 0) {
          this.previewNames = result.data.names
          this.$message.success(`解析成功，共 ${result.data.count} 个名称`)
        } else {
          this.$message.error('解析失败: ' + result.msg)
          this.fileList = []
          this.selectedFile = null
        }
      } catch (error) {
        this.$message.error('文件上传失败')
        this.fileList = []
        this.selectedFile = null
      }

      return false
    },
    // 文件移除
    handleFileRemove() {
      this.selectedFile = null
      this.previewNames = []
      this.fileList = []
    },
    getAPPList() {
      let params = {
        page: 1,
        page_size: 1000,
      };
      this.__postData('sspAppList', params, (res) => {
        if(res.list){
          this.appList = res.list
          this.appChange(this.formData.application_id)
        }
      })
    },
    // 切换地区
    handleAreaChange() {
      // 切换地区时清空关联数据
      this.form.application_id = []
      this.form.flow_types = []
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    dockingChange() {
      this.form.application_id = []
      this.form.flow_types = []
      this.form.rendering_type = 1
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    flowTypeChange(val) {
      if(val.length > 1 && val.includes(2)) {
        this.form.rendering_type = 1
      }
    },
    comodeChange() {
      this.form.min_price = null
    },
    priceBlur() {
      // 如果不是数字，清空
      if(isNaN(this.form.min_price)) {
        this.form.min_price = null
      }
      this.form.min_price=Number(this.form.min_price)  
    },
    onSave() {
      this.isDisabled = true
      this.timer = setTimeout(() => {
        this.isDisabled = false
        clearTimeout(this.timer)
      }, 1500);
      Object.values(this.form.flow_template).forEach(tplIds => {
        if (Array.isArray(tplIds)) {
          this.form.template_id.push(...tplIds)
        }
      })
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 判断是否有文件上传
          if (this.selectedFile) {
            // 有文件：使用 FormData
            this.submitWithFile()
          } else {
            // 无文件：使用原有方式（向后兼容）
            this.submitWithoutFile()
          }
        } else {
          this.isDisabled = false
          clearTimeout(this.timer);
          this.timer = null;
          return false;
        }
      })
    },
    // 不带文件提交（原有方式）
    submitWithoutFile() {
      this.__postData('adAddOrUpdateBatch', this.form, (res) => {
        console.log(res, "res")
        clearTimeout(this.timer)
        this.timer = null
        if(res.code == 1) {
          this.$message.error({
            message: res.msg,
            type: 'error'
          })
        } else {
          this.$message.success('广告位批量添加成功')
          this.closeDialog()
        }
        this.isDisabled = false
      })
    },
    // 带文件提交（新功能）
    async submitWithFile() {
      try {
        const formData = new FormData()

        // 添加文件
        formData.append('names_file', this.selectedFile)

        // 添加其他参数（数组和对象转JSON字符串）
        formData.append('application_id', JSON.stringify(this.form.application_id))
        formData.append('template_id', JSON.stringify(this.form.template_id))
        formData.append('flow_types', JSON.stringify(this.form.flow_types))
        formData.append('flow_template', JSON.stringify(this.form.flow_template))
        formData.append('batch_num', this.form.batch_num.toString())
        formData.append('co_mode', this.form.co_mode.toString())
        formData.append('area', this.form.area.toString())
        formData.append('rendering_type', this.form.rendering_type.toString())

        // 可选参数
        if (this.form.min_price !== null) {
          formData.append('min_price', this.form.min_price.toString())
        }
        if (this.form.style && this.form.style.length > 0) {
          formData.append('style', JSON.stringify(this.form.style))
        }
        if (this.form.elements && this.form.elements.length > 0) {
          formData.append('elements', JSON.stringify(this.form.elements))
        }
        if (this.form.video_sound !== undefined) {
          formData.append('video_sound', this.form.video_sound.toString())
        }
        if (this.form.video_auto_play !== undefined) {
          formData.append('video_auto_play', this.form.video_auto_play.toString())
        }
        if (this.form.callback_url) {
          formData.append('callback_url', this.form.callback_url)
        }
        if (this.form.callback_key) {
          formData.append('callback_key', this.form.callback_key)
        }

        // 国内特有参数
        if (this.form.area === 1) {
          formData.append('is_miniprogram', this.form.is_miniprogram.toString())
          formData.append('is_fast_app', this.form.is_fast_app.toString())
          formData.append('is_deeplink', this.form.is_deeplink.toString())
          formData.append('is_download_apk', this.form.is_download_apk.toString())
          formData.append('is_induce_material', this.form.is_induce_material.toString())
        }

        // 添加 media_id（从用户信息或其他地方获取）
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        if (userInfo.media_id) {
          formData.append('media_id', userInfo.media_id.toString())
        }

        const token = util.getCookie('token')
        const response = await fetch('/developer/api/adZone/addBatch', {
          method: 'POST',
          headers: {
            'Authorization': token
          },
          body: formData
        })

        const result = await response.json()

        clearTimeout(this.timer)
        this.timer = null

        if (result.code === 0) {
          this.$message.success('广告位批量添加成功')
          this.closeDialog()
        } else {
          this.$message.error(result.msg || '添加失败')
        }
        this.isDisabled = false
      } catch (error) {
        console.error('提交失败:', error)
        clearTimeout(this.timer)
        this.timer = null
        this.$message.error('请求失败，请稍后重试')
        this.isDisabled = false
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
.el-select {
  width: 100%;
}
.preview-box {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.el-upload__tip {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #909399;
  font-size: 12px;
  margin-top: 0 !important;
  line-height: 1.2;
}
/* 隐藏el-upload的虚线框 */
::v-deep .el-upload {
  display: inline-flex !important;
  border: none !important;
  pointer-events: none;
  width: fit-content !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
  min-width: auto !important;
}
::v-deep .el-upload .el-button {
  pointer-events: auto;
}
::v-deep .el-upload-dragger {
  display: none;
}
::v-deep .el-upload__input {
  display: none !important;
}
/* 移除所有el-upload相关的边框和虚线 */
::v-deep .el-upload--text {
  border: none !important;
}
::v-deep .el-upload-list {
  margin-top: 10px;
}
/* 减少自定义名称表单项的底部间距 */
.upload-form-item {
  margin-bottom: 18px;
}
</style>